const mistakes = [
  {
    icon: "ri-calendar-close-line",
    title: "The Canal-Storage Passport Trap",
    description:
      "You live on a canal in Cape Coral and keep your passport in a drawer, a boat safe, or a storage closet near the water. The humidity that makes Southwest Florida beautiful also slowly degrades documents stored in non-climate-controlled spaces. You have not used your passport since that Cancun trip two years ago. Now you are booking a Caribbean cruise for February, and the passport is stuck together, the binding is separating, or mold spots have appeared on the cover. It is not just expired — it is damaged, which means it is invalid.",
    fix: "Store important documents in a climate-controlled interior space, not a garage, boat safe, or waterfront closet. Check your passport every September before booking winter travel. Humidity damage is irreversible.",
  },
  {
    icon: "ri-parent-line",
    title: "The Child Passport Expiration Surprise",
    description:
      "Your daughter is now 10. Her passport was issued when she was 5 — which means it expired last year on her 10th birthday. You just booked her first spring break cruise to the Bahamas through the deal you found on Allegiant from Punta Gorda, and the cruise line requires a valid passport number for every passenger at booking. Child passports are only valid for 5 years, and many parents forget this shorter timeline until it is too late.",
    fix: "Set a reminder for every child's passport expiration 6 months before it expires. Start renewal early for family travel, especially cruises with strict booking deadlines and Allegiant flights that require passport numbers at purchase.",
  },
  {
    icon: "ri-time-line",
    title: "The Six-Month Validity Oversight",
    description:
      "Your passport expires in August, and your Cancun all-inclusive is in June. You assume you are fine because it is still valid. But Mexico requires six months of validity beyond your departure date. The airline denies boarding at RSW, and your non-refundable resort package — booked at that great Allegiant deal price — is gone.",
    fix: "Renew if your passport expires within 6–9 months of any international trip. All-inclusive resort packages and budget airline deals are typically non-refundable within 30–60 days of departure.",
  },
  {
    icon: "ri-image-line",
    title: "The Wrong Photo",
    description:
      "You took a passport photo at the pharmacy on Del Prado Boulevard using a blue background because it matched your shirt. Or your child was smiling because the photographer said \"cheese.\" Or your sunglasses left a shadow. The State Department rejects the photo, and your application is delayed by 2–3 weeks while you resubmit. For a spring break trip that cost you $189 round-trip on Allegiant, that delay means losing the whole vacation.",
    fix: "Follow State Department photo guidelines exactly: white/off-white background, neutral expression, no glasses, correct size (2×2 inches). We review your photo before submission to eliminate rejections.",
  },
  {
    icon: "ri-file-damage-line",
    title: "The Damaged Passport",
    description:
      "Your passport went through a fishing trip, got wet in a tackle box, or the binding came loose from years of humidity in your Cape Coral home. You think it is still usable because the data page is readable. The airline at RSW or the cruise terminal in Miami disagrees, and you are denied boarding.",
    fix: "Any physical damage, water damage, or unauthorized markings make a passport invalid. Replace it immediately through expedited service before any international travel.",
  },
  {
    icon: "ri-draft-line",
    title: "The Form Error",
    description:
      "You filled out the DS-11 or DS-82 form online, printed it, and signed it. But you used blue ink instead of black, signed outside the box, or left a required field blank. The acceptance clerk catches it, or worse, the State Department rejects the application after weeks of processing — right before your spring break or cruise departure.",
    fix: "Use black ink only, sign within the box boundaries, and double-check every field. We pre-review all forms before submission to eliminate this risk entirely.",
  },
];

export default function CapeCoralMistakesSection() {
  return (
    <section className="py-16 md:py-20 bg-[#F8F9FB]">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <span className="inline-block text-[#B22222] text-xs font-bold uppercase tracking-[0.15em] mb-3">
            Avoid These Mistakes
          </span>
          <h2 className="font-serif text-2xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Common Passport Mistakes Cape Coral Travelers Make
          </h2>
          <p className="text-gray-600 text-sm md:text-base max-w-2xl mx-auto leading-relaxed">
            These are the errors we see most often from Cape Coral travelers. Each one can cost you a cruise, a spring break trip, or weeks of stress.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6">
          {mistakes.map((m, i) => (
            <div
              key={i}
              className="bg-white rounded-lg p-6 border border-gray-100 hover:border-[#F6C344]/50 transition-all"
            >
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 rounded-lg bg-[#B22222]/10 flex items-center justify-center shrink-0">
                  <i className={`${m.icon} text-[#B22222] text-lg`}></i>
                </div>
                <div>
                  <h3 className="font-serif text-base font-bold text-[#1A365D] mb-2">{m.title}</h3>
                  <p className="text-gray-600 text-sm leading-relaxed mb-3">{m.description}</p>
                  <div className="bg-[#F8F9FB] rounded-md p-3">
                    <p className="text-emerald-700 text-xs font-semibold mb-0.5">
                      <i className="ri-check-line mr-1"></i>How to avoid it:
                    </p>
                    <p className="text-gray-600 text-xs leading-relaxed">{m.fix}</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}